exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-card__badge,.admin-tags__item{cursor:pointer}", ""]);

// exports
